import devConfigs from './dev';
import prodConfigs from './prod';

let configs;

if (process.env.NODE_ENV === 'production') {
    configs = prodConfigs;
} else {
    configs = devConfigs;
}

export default Object.freeze(configs);